import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";

function JiliFreeSpinsPromo(props) {
  const {
    app: { brandId },
    theme,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const domain = brandId == 31 || brandId == 32 || brandId == 61 ? "YOLO247" : brandId == 39 || brandId == 40 ? "FOMO7" : "IW247";

  return (
    <>
      <InformationWrapper>
        {/* Top Caption */}

        {/* Left Model */}
        <ModelWrapper>
          <img
            src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsLeftModalDesk}`}
            alt="Model"
            className="modelImg"
          />
        </ModelWrapper>

        {/* Main Right Section */}
        <RightSection>
        <TopCaption>
          START 2026 ON <span className="brand">{domain}</span> WITH 26 FREE SPINS
          ON <span className="brand">JILI SLOTS.</span> SIGN UP, <br /> LAUNCH YOUR <span className="brand">FIRST JILI GAME</span>, AND SPIN
          INSTANTLY.
        </TopCaption>
          {/* HOW TO */}
          <SectionTitle>
            <span className="lite">HOW TO</span>
            <span className="bold">PARTICIPATE</span>
          </SectionTitle>

          <StepsRow>
            <StepCard>
               <img
            src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps01Desk}`}
            alt="Model"
            className="modelImg"
          />
            </StepCard>

            <StepCard>
              <img
            src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps02Desk}`}
            alt="Model"
            className="modelImg"
          />
            </StepCard>

            <StepCard>
            <img
            src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps03Desk}`}
            alt="Model"
            className="modelImg"
          />
            </StepCard>
          </StepsRow>

          {/* TERMS */}
          <TermsTitle>
            <span className="lite">TERMS &</span>
            <span className="bold">CONDITIONS</span>
          </TermsTitle>

          <TermsCard>
            <ul>
              <li>Valid once per user</li>
              <li>
                Free spin value: <span className="boldTextLite">₹1 per spin</span>
              </li>
              <li>
                <span className="boldTextLite">Free spins are credited</span>{" "}
                upon first launch of <br /> any Jili Slots game
              </li>
              <li>Slot bonus rules apply</li>
              <li>Bonus winnings subject to wagering of 5x</li>
              <li>General {domain} terms & conditions apply</li>
            </ul>
          </TermsCard>
        </RightSection>
      </InformationWrapper>

    </>
  );
}

export default withTheme(withAppContext(JiliFreeSpinsPromo));

/* ===================== STYLES ===================== */

const InformationWrapper = styled.div`
  width: 98%;
  height: auto;
  padding: 1.5rem 0 5rem 0;
  margin: 0em 1.2em 0 1.2em;
  border: 1px solid #fff;
  display: flex;
  flex-direction: column;
  background: url(${config.imageV3Host}/static/cashsite/${theme("image.jilliFreeSpinsInnerBgDesk")});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  min-height: 900px;

  .boldText {
    color: ${theme("palette.informationWrapperPromoBoldText")};
    font-weight: 700;
  }

  .boldTextLite {
    color: #ffffff;
    font-weight: 700;
  }

  .brandColor {
    color: ${theme("palette.suprChknRushBrandTextColor")};
    font-weight: 700;
  }
`;

const TopCaption = styled.p`
  width: 100%;
  text-align: text;
  font-size: 13px;
  letter-spacing: 1px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.65);
  text-transform: uppercase;
  margin-bottom: 2rem;

  .brand {
    color: #fff;
    font-weight: 700;
  }
`;

const ModelWrapper = styled.div`
  position: absolute;
  left: 2.5rem;
  top: 6.5rem;
  width: 360px;
  height: 750px;

  .modelImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0px 12px 30px rgba(0, 0, 0, 0.7));
  }
`;

const RightSection = styled.div`
  margin-left: 430px;
  padding-right: 5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 3.5rem;
`;

const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 1rem;

  .lite {
    font-size: 38px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.25);
    letter-spacing: 1px;
  }

  .bold {
    font-size: 38px;
    font-weight: 800;
    letter-spacing: 1px;
    color: #fff;
    margin-left: 65px;
  }
`;

const StepsRow = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
`;

const StepCard = styled.div`
  width: 255px;
  height: 133px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  box-shadow: 0px 14px 30px rgba(0, 0, 0, 0.25);



  .stepNum {
    font-size: 12px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.55);
    position: absolute;
    top: 10px;
    left: 14px;
  }

  .stepText {
    width: 50%;
    padding-top: 22px;
    font-size: 14px;
    font-weight: 700;
    color: #111;
    line-height: 1.15;
  }

  .stepImg {
    width: 42%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
      object-fit: cover;
    }
  }
`;

const TermsTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 2.2rem;

  .lite {
    font-size: 32px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.25);
    letter-spacing: 1px;
  }

  .bold {
    font-size: 32px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 1px;
    margin-left: 65px;
  }
`;

const TermsCard = styled.div`
  width: 450px;
  height: 223px;
  background: rgba(0, 0, 0, 0.45);
  padding: 22px 28px;
  background: url(${config.imageV3Host}/static/cashsite/${theme("image.jilliFreeSpinsTermsBgDesk")});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  &::after{
    content: "";
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.jilliFreeSpinsTermsRightDesk")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    right: -40px;
    top: -50px;
    width: 113px;
    height: 102px;
  }

  ul {
    margin: 0;
    padding-left: 1.15rem;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;

    li {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 1.35;
    }
  }
`;